<template>
  <div>
    <TheAdminDashboard v-if="isAdminOrSuperAdmin" />
    <TheCollaboratorDashboard v-else />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import TheAdminDashboard from '@/views/TheAdminDashboard.vue';
import TheCollaboratorDashboard from '@/views/TheCollaboratorDashboard.vue';

export default defineComponent({
  name: 'TheDashboard',
  components: {
    TheAdminDashboard,
    TheCollaboratorDashboard,
  },
  computed: {
    ...mapState(useAuthStore, ['user']),
    isAdminOrSuperAdmin(): boolean {
      return this.user?.role === 'admin' || 
             this.user?.role === 'super_admin' || 
             this.user?.roles?.some((r: any) => r.name === 'admin' || r.name === 'super_admin') || 
             false;
    },
  },
});
</script>
